export default "__VITE_ASSET__1f94cdbf__"